function getURLVar(key) {
    var value = [];

    var query = String(document.location).split('?');

    if (query[1]) {
        var part = query[1].split('&');

        for (i = 0; i < part.length; i++) {
            var data = part[i].split('=');

            if (data[0] && data[1]) {
                value[data[0]] = data[1];
            }
        }

        if (value[key]) {
            return value[key];
        } else {
            return '';
        }
    }
}
function isEmpty(el) {
    return !$.trim(el.html())
}
$(document).ajaxStop(function () {
    function isEmpty(el) {
        return !$.trim(el.html())
    }

    if (!isEmpty($('#product'))) {
        $('#product .option-container').addClass('has-option');
    }
});
function divWidthMenu() {
    var width_br = $(".container-fix .block-right").outerWidth(true);
    var width_count = $(".container-fix > .container").width();
    var width_bl = $("#logo img").outerWidth(true);
    if ($(".hd1").length || $(".hd2").length) {
        $('.home1 .container-fix .main-menu').outerWidth(width_count - width_bl - width_br - 30);
    }
}

function customResponsive() {
    var window_w = parseInt($(window).width());

    $(".group1 #logo img").each(function () {
        if (this.complete) {
            divWidthMenu.call(this);
        } else {
            $(this).one('load', divWidthMenu);
        }
    });

    var offsetMargin = 0 - $('.wrapper').outerWidth(true) * 2.6 / 100;
    if ($(".hd2").length) {
        $('.banner8').css('margin-left', offsetMargin);
        $('.banner8').css('margin-right', offsetMargin);
    }
}
$(window).resize(function () {
    customResponsive();
});

$(document).ready(function () {
    var className = $('header').attr('class');
    if ($(".header3").length) {
        $('.contentforlayout').addClass('container1-page');
    }

    bindAddToCart();


});


function bindAddToCart() {


    // color swatch js snippet
    $('.swatch :radio').change(function () {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this)
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
    });

    //look here
    $(".quick_shop_cart").off().on('click', function (e) {
        e.preventDefault();
        $(this).closest(".quick_shop_wrap").removeClass("active");

        $(".quickshop").css("display", "");
    });

    $('.cart_button').on('mouseover', function (e) {
        if ($('.cart_button').attr('variant-id') === "") {
            $(this).css("cursor", "not-allowed");
        } else {
            $(this).css("cursor", "pointer");
        }
    });
    // product page add to cart
    $('.cart_button').on('click', function (e) {
        e.preventDefault();

        if ($('.cart_button').attr('data-variant-id') === "") {
            swal("Please select size!", "");
            return;
        }

        var productId = $(this).attr("data-product-id");
        var productData = $(".single-option-selector-product-template-" + productId + ",select#ProductSelect-product-template-" + productId);

        var formData = {
            id: $(this).attr('data-variant-id'),
            quantity: $('form[action="/cart/add"]').find('#Quantity').val()
        };
        $.ajax({
            url: '/cart/add.js',
            type: 'post',
            data: formData,
            dataType: 'json',
            beforeSend: function () {

            },
            complete: function () {

            },
            success: function (json) {
                $('.alert, .text-danger').remove();
                $('.form-group').removeClass('has-error');

                if (json['error']) {
                    if (json['error']['option']) {
                        for (i in json['error']['option']) {
                            var element = $('#input-option' + i.replace('_', '-'));
                            if (element.parent().hasClass('input-group')) {
                                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
                            } else {
                                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
                            }
                        }
                    }

                    if (json['error']['recurring']) {
                        $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
                    }


                } else {

                    swalIncrementCartCOunter(productId);

                }

                $.getJSON('/cart.js', function (cart) {
                    $('.cart_counter').html(cart.item_count);
                });

                //$('html, body').animate({ scrollTop: 0 }, 'slow');

                $('#cart').load('/ #cart #subcart');

            },
            error: function (xhr, ajaxOptions, thrownError) {
                swal(xhr.responseJSON.message, xhr.responseJSON.description, "error", {

                    buttons: {
                        defeat: "Add to Wishlist",
                        catch: "Close"
                    },

                }).then(function (value) {
                    switch (value) {

                        case "defeat":
                            var wishlistform = $('form#wish-list');

                            var loggedInCustomerId = $('#customerId').val();
                            var selectedVariantId = $('#wishlistButton').attr("data-variant-id");
                            var selectedVariantTags = $('#wishlistButton').attr("data-variant-tags");
                            var customer_details_string = selectedVariantId + selectedVariantTags;

                            if (wishlistform.length > 0 && loggedInCustomerId) {
                                $.ajax({
                                    url: "https://youngsolesapp.netlify.app/.netlify/functions/update-details?customer_id=" + loggedInCustomerId + "&tags=" + customer_details_string,
                                    type: "POST",
                                    dataType: "json",
                                    success: function (response) {
                                        swal("Added to wishlist successfully!", "");
                                        location.reload();

                                    },
                                    error: function (error) {
                                        swal(error.responseText, "error");
                                    }
                                });
                            } else {
                                var url = window.location.href;
                                swal("To create a wish list you must ", {
                                    buttons: {
                                        defeat: "Sign in",
                                        catch: "Create account"
                                    },
                                })
                                    .then(function (value) {
                                        switch (value) {

                                            case "defeat":

                                                window.location.href = "/account/login?url=" + url;
                                                break;

                                            case "catch":
                                                window.location.href = "/account/register";
                                                break;
                                        }
                                    });
                            }


                            break;

                        case "catch":
                            swal.close();
                            break;
                    }
                });
            }
        });
    });

    // product page add to cart
    //look here
    $('.shop_cart_button').on('click', function (e) {
        if ($(this).hasClass("wishlist-btn")) {

            return;
        }

        $(".thumbnail").css("opacity", "1");
        var productId = $(this).attr("data-product-id");
        var selectedVariantId = $(this).parent().parent().next().find('a.select-variant-id').attr("data-variant-id");
        var productData = $(".single-option-selector-product-template-" + productId + ",select#ProductSelect-product-template-" + productId);
        if(!selectedVariantId || !selectedVariantId.length){
          selectedVariantId =  $(this).parent().parent().parent().find(".selected-variant-id").val();
        }
        e.preventDefault();
        $.ajax({
            url: '/cart/add.js',
            type: 'post',
            data: {quantity: 1, id: selectedVariantId},
            dataType: 'json',
            beforeSend: function () {

            },
            complete: function () {

            },
            success: function (json) {
                $('.alert, .text-danger').remove();
                $('.form-group').removeClass('has-error');

                if (json['error']) {
                    if (json['error']['option']) {
                        for (i in json['error']['option']) {
                            var element = $('#input-option' + i.replace('_', '-'));
                            if (element.parent().hasClass('input-group')) {
                                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
                            } else {
                                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
                            }
                        }
                    }

                    if (json['error']['recurring']) {
                        $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
                    }

                } else {

                    swalIncrementCartCOunter(productId);

                }

                $.getJSON('/cart.js', function (cart) {
                    $('#cart-total').html(cart.item_count);
                });

                $('#cart').load('/ #cart #subcart');
                $(".shop_cart_div").css("display", "none");
                $(".quick_shop_button-" + productId).css("display", "");
                $(".product_image_item").css("opacity", "");
            },
            error: function (xhr, ajaxOptions, thrownError) {
                swal(xhr.responseJSON.message, xhr.responseJSON.description, "error");
                $(".quick_shop_wrap").removeClass("active");
                $(".shop_cart_div").css("display", "none");
            }
        });
    });

    $('.container-fix').hover(function () {
        $(this).addClass("fix-header-act");
    }, function () {
        $(this).removeClass("fix-header-act");
    });

    customResponsive();

    if (!isEmpty($('#product'))) {
        $('#product .option-container').addClass('has-option');
    }
    if (!isEmpty($('#product2'))) {
        $('#product2 .option-container').addClass('has-option');
    }

    // move toolbar category
    $('.layer-category').prepend($('.custom-category .toolbar'));

    // Highlight any found errors
    $('.text-danger').each(function () {
        var element = $(this).parent().parent();

        if (element.hasClass('form-group')) {
            element.addClass('has-error');
        }
    });

    /* Search */
    $('#search input[name=\'q\']').parent().find('button').on('click', function () {
        var url = '/search';

        var value = $('#search input[name=\'q\']').val();
        if (value == "Search all products..." || value == "") {
            jQuery('#search input[name=\'q\']').focus();
            return false;
        } else {
            url += '?type=product&q=' + encodeURIComponent(value);
        }

        location = url;
    });

    $('#search input[name=\'q\']').on('keydown', function (e) {
        if (e.keyCode == 13) {
            $('#search input[name=\'q\']').parent().find('button').trigger('click');
        }
    });

    // Menu
    $('#menu .dropdown-menu').each(function () {
        var menu = $('#menu').offset();
        var dropdown = $(this).parent().offset();

        var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());

        if (i > 0) {
            $(this).css('margin-left', '-' + (i + 10) + 'px');
        }
    });

    // Product List
    $('#list-view').click(function () {
        $('.custom-products').removeClass('custom-products-row');
        $(this).addClass('selected');
        $('#grid-view').removeClass('selected');
        $('#content .product-grid > .clearfix').remove();

        //$('#content .product-layout').attr('class', 'product-layout product-list col-xs-12');
        $('#content .product-grid').attr('class', 'product-layout product-list col-xs-12');
        $('#content .product-list .caption').addClass('col-xs-8');
        $('#content .product-list .image').addClass('col-xs-4');


        localStorage.setItem('display', 'list');
    });

    // Product Grid
    $('#grid-view').click(function () {
        $('.custom-products').addClass('custom-products-row');
        $(this).addClass('selected');
        $('#list-view').removeClass('selected');
        // What a shame bootstrap does not take into account dynamically loaded columns
        cols = $('#column-right, #column-left').length;

        if (cols == 2) {
            $('#content .product-layout').attr('class', 'product-layout product-grid col-md-6 col-sm-6 col-xs-6 two-items');
        } else if (cols == 1) {
            $('#content .product-layout').attr('class', 'product-layout product-grid col-md-4 col-sm-6 col-xs-6 three-items');
        } else {
            $('#content .product-layout').attr('class', 'product-layout product-grid col-md-3 col-sm-6 col-xs-6 four-items');
        }
        $('#content .product-grid .caption').removeClass('col-xs-8');
        $('#content .product-grid .image').removeClass('col-xs-4');


        localStorage.setItem('display', 'grid');
    });

    if (localStorage.getItem('display') == 'list') {

        $('#list-view').trigger('click');
    } else {
        $('#grid-view').trigger('click');
    }

    // Checkout
    $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function (e) {
        if (e.keyCode == 13) {
            $('#collapse-checkout-option #button-login').trigger('click');
        }
    });

}

function swalIncrementCartCOunter(productId) {
    swal("Added to shopping bag successfully !", "");
    $.getJSON('/cart.js', function (cart) {
        $('.cart_counter').html(cart.item_count);
    });
    $(".quick_shop_wrap").removeClass("active");
    $(".shop_cart_div").css("display", "none");
    $(".product_image_item > a").find("img").css("opacity", "");
    //$(".quick_shop_button-"+productId).css("display", "inherit");

}

// Cart add remove functions
var cart = {
    'add': function (product_id, product_title, quantity) {
        $.ajax({
            url: '/cart/add.js',
            type: 'post',
            data: 'id=' + product_id + '&quantity=' + (typeof (quantity) != 'undefined' ? quantity : 1),
            dataType: 'json',
            beforeSend: function () {
            },
            complete: function () {

            },
            success: function (json) {
                $('.alert, .text-danger').remove();


                swal(product_title, "is added to shopping bag !", "success");
                // toastr.success('Congratulation! Your item has been added.')

                $.getJSON('/cart.js', function (cart) {
                    setTimeout(function () {
                        $('.cart_counter').html(cart.item_count);
                    }, 100);
                    //Currency.convertAll(shopCurrency, Currency.cookie.read());
                });
                $('#cart').load('/ #cart #subcart');
            },
            error: function (xhr, ajaxOptions, thrownError) {
                swal(xhr.responseJSON.message, xhr.responseJSON.description, "error");
            }
        });
    },
    'remove': function (lineKey) {

        $.ajax({
            url: '/cart/change.js',
            type: 'post',
            data: 'line=' + lineKey + '&quantity=0',
            dataType: 'json',
            beforeSend: function () {
                $('#cart').removeClass('show-header-dropdown');
            },
            success: function (json) {

                $('#cart > button').button('reset');
                setTimeout(function () {
                    $('.cart_counter').html(json['item_count']);
                }, 100);
                // Currency.convertAll(shopCurrency, Currency.cookie.read());

                if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout') {
                    location = '/cart';
                } else {
                    $('#cart').load('/ #cart #subcart');
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {

                swal(xhr.responseText.message, xhr.responseText.description, "error");
            }
        });
    }
}

/* Agree to Terms */
$(document).delegate('.agree', 'click', function (e) {
    e.preventDefault();

    $('#modal-agree').remove();

    var element = this;

    $.ajax({
        url: $(element).attr('href'),
        type: 'get',
        dataType: 'html',
        success: function (data) {
            html = '<div id="modal-agree" class="modal">';
            html += '  <div class="modal-dialog">';
            html += '    <div class="modal-content">';
            html += '      <div class="modal-header">';
            html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
            html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
            html += '      </div>';
            html += '      <div class="modal-body">' + data + '</div>';
            html += '    </div>';
            html += '  </div>';
            html += '</div>';

            $('body').append(html);

            $('#modal-agree').modal('show');
        }
    });
});

// Autocomplete */
(function ($) {
    $.fn.autocomplete = function (option) {
        return this.each(function () {
            this.timer = null;
            this.items = new Array();

            $.extend(this, option);

            $(this).attr('autocomplete', 'off');

            // Focus
            $(this).on('focus', function () {
                this.request();
            });

            // Blur
            $(this).on('blur', function () {
                setTimeout(function (object) {
                    object.hide();
                }, 200, this);
            });

            // Keydown
            $(this).on('keydown', function (event) {
                switch (event.keyCode) {
                    case 27: // escape
                        this.hide();
                        break;
                    default:
                        this.request();
                        break;
                }
            });

            // Click
            this.click = function (event) {
                event.preventDefault();

                value = $(event.target).parent().attr('data-value');

                if (value && this.items[value]) {
                    this.select(this.items[value]);
                }
            }

            // Show
            this.show = function () {
                var pos = $(this).position();

                $(this).siblings('ul.dropdown-menu').css({
                    top: pos.top + $(this).outerHeight(),
                    left: pos.left
                });

                $(this).siblings('ul.dropdown-menu').show();
            }

            // Hide
            this.hide = function () {
                $(this).siblings('ul.dropdown-menu').hide();
            }

            // Request
            this.request = function () {
                clearTimeout(this.timer);

                this.timer = setTimeout(function (object) {
                    object.source($(object).val(), $.proxy(object.response, object));
                }, 200, this);
            }

            // Response
            this.response = function (json) {
                html = '';

                if (json.length) {
                    for (i = 0; i < json.length; i++) {
                        this.items[json[i]['value']] = json[i];
                    }

                    for (i = 0; i < json.length; i++) {
                        if (!json[i]['category']) {
                            html += '<li data-value="' + json[i]['value'] + '"><a href="#">' + json[i]['label'] + '</a></li>';
                        }
                    }

                    // Get all the ones with a categories
                    var category = new Array();

                    for (i = 0; i < json.length; i++) {
                        if (json[i]['category']) {
                            if (!category[json[i]['category']]) {
                                category[json[i]['category']] = new Array();
                                category[json[i]['category']]['name'] = json[i]['category'];
                                category[json[i]['category']]['item'] = new Array();
                            }

                            category[json[i]['category']]['item'].push(json[i]);
                        }
                    }

                    for (i in category) {
                        html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';

                        for (j = 0; j < category[i]['item'].length; j++) {
                            html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
                        }
                    }
                }

                if (html) {
                    this.show();
                } else {
                    this.hide();
                }

                $(this).siblings('ul.dropdown-menu').html(html);
            }

            $(this).after('<ul class="dropdown-menu"></ul>');
            $(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));

        });
    }
})(window.jQuery);